module.exports = __webpack_public_path__ + "static/media/img_homepage_content_Resourcefoyou-03_Secondry-School.a422ef41.png";